import { useMutation } from '@tanstack/react-query';
import postNotifications from 'Api/monitoring/postNotifications';

const usePostNotification = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const result = await postNotifications(payload);

      return result;
    },
  });
};

export default usePostNotification;
